import {collection, dateField, field, LocalisableEntityData, transientField} from "@fedeltapointofsale/data-client";
import {ReportData} from "../../../reports/report.data";


export class BalanceTillSummaryReportData extends ReportData<BalanceTillSummaryReportData> {
    @collection() groupBy: string[] = ["none"];
}
